import React from 'react'
import styles from './styles.css'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'

@withMessage
export default class Fail extends React.Component {

  static propTypes = {
  }

  state = {
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Pago Fallido</h3>
          </div>
          <div className="content">
            <p>Lamentablemente su pago no pudo ser completado.</p>
            <Button primary onClick={() => this.props.router.push(`/settings/firmasDigitales`) } >
              Reintentar
            </Button>
          </div>         
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Payment/Fail/index.js